<template>
    <!--Enrollment Congratulation-->
    <div class="enrollment-congratiulation ">
        <div class="enrollment-inner-wrap section-wrap">
            <div class="congrat-image-wrap">
                <img src="../../../../assets/images/enrollment-congratiulation.png" alt="Congratiulation">
            </div>
            <p v-html="text"></p>
        </div>
        <div class="next-step">
            <button v-if="!goToDashboard" @click="changeScreen()" class="primary-btn extra-small mobile">
                {{ buttonText }}
            </button>
            <router-link v-if="goToDashboard" class="primary-btn extra-small mobile"
                :to="{ path: '/app/waiting-list/dashboard' }">
                {{ buttonText }}
            </router-link>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        text: {
            type: String,
            required: true
        },
        nextScreen: {
            type: String,
            required: false
        },
        buttonText: {
            type: String,
            required: true
        },
        goToDashboard: {
            type: Boolean,
            required: false
        },
    },
    data() {
        return {};
    },
    computed: {},
    mounted() {

    },
    components: {},
    methods: {
        changeScreen() {
            this.$emit('change-screen', this.nextScreen);
        },
    },
};
</script>
